
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `Vrij`,
'deleteKey': `Verwijderen`,
'downKey': `↓ Omlaag`,
'endKey': `⤓ Einde`,
'enterKey': `Ga naar`,
'escapeKey': `Ontsnappen`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Een 
          <code>LICENTIE 
          </code> bestand 
        `,
'homeKey': `⤒ Home`,
'keyCommand': `Commando/Win`,
'keyControl': `^ Controle`,
'keyOption': `Optie/Alt`,
'keyShift': `Verschuiving`,
'leftKey': `← Links`,
'pagedownKey': `Pagedown`,
'pageupKey': `Pagina omhoog`,
'rightKey': `→ Rechts`,
's00065e45db8c0441': `Zie Hulpprogramma's voor ontwikkelaars voor meer informatie`,
's001dd78415a91fa0': `Scrollbalk goot`,
's002fa7d1054ed082': `Randvak`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazachs`,
's01b56d233c6c5cac': `Sectie`,
's01d32b35baa3b676': `Auteur`,
's02106cc2ef0e7578': `Nieuwe pin...`,
's02ab1ea8e5100fc1': `Markeer de selectie als een 'bidirectionele opheffing'.`,
's0312976fe9da5951': `Knop`,
's03608a32f05eded2': `Knijpen zoom`,
's036d35e03be98d22': `Wiskunde diepte`,
's037b1dc850a89273': `Alternatief onder`,
's0396202b716732ec': `Markeer de selectie als doorgeslagen`,
's03f49e598ffb11cc': `Pools`,
's0448f1059fa01720': `Je explorable opslaan, delen of afdrukken. Bewerk informatie zoals de titel, taal of licentie.`,
's0458872c43beadef': `Rij invoegen vóór`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Woordafstand`,
's05e9759cfd99c48f': `Rechtvaardigen`,
's063fa5a0a4903bf4': `Zijwaarts, van links naar rechts`,
's064339c229374050': `Codering`,
's06634274f19b0572': `Pin selectie`,
's06743b24499f0035': `Ankercentrum`,
's07808b0ca6da8fef': `Omheinde website`,
's07970793b21351fd': `Ruby basiscontainer`,
's079cf7850d9327f0': `Lettertype`,
's07aa10850d9ddcc7': `Formulier`,
's07e6118e838b2e23': `Navigatie`,
's0816468df86e4036': `Opent de instellingen`,
's082869038c117fe5': `Portugees (Brazilië)`,
's086e6c267ade2609': `Verzadiging`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Een lijst invoegen (ongeordend)`,
's09c3f1d21de14ae1': `Markeer de selectie als onderstreept`,
's0a2d91c6720033e9': `Tekst spatiëring`,
's0a3ddcba94027d95': `Object geschikt`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Een navigatie invoegen`,
's0a7db790db1fc45c': `Markeer de selectie als een overspanning`,
's0b1271f50a77dc73': `Inhoud vak`,
's0b24d08ea349b455': `Alles wat je kunt invoegen. In het begin staan niet-interactieve elementen zoals lijsten of afbeeldingen, daarna komen interactieve elementen die widgets worden genoemd. Je kunt nieuwe widgets krijgen door op de zoekbalk te klikken.`,
's0bdca49248ba4820': `Snelkoppelingen`,
's0befccf152b6c0a9': `Oriënteren op metagegevens`,
's0c11e479416c8421': `Een tabelopschrift invoegen`,
's0c27336067c59611': `Scroll opvulling`,
's0c4593d81f147042': `Basislijn`,
's0c4b2e98d4ab7f5a': `App-opdrachten`,
's0c883713b83616a8': `Het actieve document opslaan`,
's0ca5c0460199cba1': `Afkorting`,
's0cf10c4f40588f8d': `Tabel Opschrift`,
's0d86afa3c6a1e28b': `Flexrichting`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Je verkenbare document. Je kunt hier tekst schrijven en kopiëren/plakken, bewerken, enz.`,
's0dc452999c129e15': `Live herladen inschakelen`,
's0de0febab8a4beaf': `Fout bij het lezen van dit pakket`,
's0e44968489e076a8': `Chinees`,
's0e4862e87c7d53ce': `Markeer de selectie als een citaat`,
's0e6ea8870dbddab2': `Documentopdrachten`,
's0ee28503778e4c0c': `Laatste basislijn`,
's0ef01c03299bbb83': `Decoratie`,
's0f17f32919661cff': `Mongools`,
's0f350bc4e538e3ea': `Woorden`,
's105a06836c40fcb4': `Filters, kleur en overvloeiing van geselecteerde elementen instellen`,
's106b274b5af798e5': `Zinnen`,
's1082e1649793dca9': `Markeer de selectie als een gedefinieerde term`,
's10f3845975a0351e': `Metagegevens bewerken`,
's1125d159f7e64df5': `Weergave`,
's11326fd2590f4e5e': `Standaard`,
's1155ec07a221e739': `Scrollbalk`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's1177237a3e0e548c': `Minimum (x)`,
's1219d97b49650c05': `Zichtbaarheid`,
's123bea44f38abccf': `Object invoegen`,
's1245e2cb9f20197e': `uitlijnen`,
's12946ec1b850962c': `Kolom invoegen na`,
's1351209ef74ee729': `Alle kolommen overspannen`,
's13c60cb409e8cb6f': `Midden uitlijnen`,
's13ebd619c8a06a6d': `Raster autorijen`,
's13ef8ca26ca8861b': `Gesneden element`,
's151bc2eea7a032a4': `-ongewijzigd-`,
's153bc3c3aa39587b': `Tafelhoofd`,
's156647179b21d351': `Een tabel invoegen`,
's158b6ec6b1fffcb2': `Pauze na`,
's15d0c0657c1ee08c': `API-sleutel`,
's1626a7e10a9f9dcc': `Stelt de lettertypefamilie van de selectie in`,
's1637c7d1a30629e2': `Kader`,
's1641ab440bf4daa4': `Dit widgetpakket bijwerken`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Geavanceerd: Toon pakketten met versies zoals 0.x.x in de pakketbeheerder`,
's16b9446e3a70e1f4': `Attributen`,
's16f205466761e583': `Geen optische lettergrootte`,
's16f2f1c2c516d307': `Een document openen`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `Licentie`,
's17bfaaa4e7528bc7': `Basjkir`,
's17fb3f4805f4f4b9': `Veld verwijderen`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Pakket maken`,
's18d5c44aae3dc82a': `Online tijdens bewerken`,
's1988d71ef8060edf': `Een tabelrij invoegen`,
's19abee1277c9bca2': `Samoaans`,
's19daf2f26c19543d': `Schets`,
's1a1acc902e6668e0': `Geavanceerde tekstopmaak weergeven`,
's1a5230a71d9285c1': `Vang`,
's1aa1cb63ad44bc6f': `Kolom opening`,
's1af8b67d1c85c811': `Ruimte tussen`,
's1b4a36fce2456660': `Lettertype familie`,
's1c246045629b0016': `Markeer de selectie als een verwijdering`,
's1c3fc313a9184670': `Openbare link`,
's1c65f5004a07dcfa': `Schots-Gaelisch`,
's1c690963f1e2df00': `Platform-specifiek uiterlijk`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Wil je een korte rondleiding?`,
's1d19244f549ec535': `Onderwijs`,
's1d5c7b28e8b50d6d': `Geassocieerde graad.`,
's1db591f5a54dbfd3': `Inhoud vak`,
's1dbb9f50e16c92a3': `Grensradius`,
's1dfb744260fb3a01': `Bidirectionele isolatie`,
's1e9c2c654732cc5f': `Wit-Russisch`,
's1eaccbf2d6af8ab5': `Informatie`,
's1efbfc3937d565bd': `Achtergrond`,
's1f2b49c1bca2035d': `Catalaans`,
's1f74bdf32b51a5fc': `Achtergrondafbeelding`,
's1f7698c061c208c9': `Open`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Corsicaanse`,
's21d61916eb8d137d': `Tabel Lichaam`,
's21d723a1dbcd89c8': `Javaans`,
's21f8a2eaf5a70749': `Een label invoegen`,
's2206c42e5b835e6e': `Markeer de selectie als een afkorting`,
's22a2348c46a912a0': `Een sectie invoegen`,
's233ae776268cd44b': `Bedrijf`,
's236ed7ba747099b0': `Lettertype gewicht`,
's2474e7fb1aec9f05': `Test`,
's2492f5fb1b05b45e': `Tekst`,
's24949d7adbb5a098': `Gereedschapskist`,
's252a52330d32b900': `Metagegevens`,
's2540844a4bc4d9ba': `Naamsvermelding vereist?`,
's255857544a9d5ec0': `Reset`,
's255c77900f2b5e0f': `Kleurenschema`,
's256ab831a48c941c': `Verwijdert alle tekstopmaak van de selectie`,
's2591806d7b222591': `Wijzigingen resetten`,
's25e1a07e454c2c11': `Rooster`,
's262abbaf1d05f009': `Zacht licht`,
's266935f2447fcd98': `Over links`,
's268ecd1cef45a9a8': `Weet je het zeker?`,
's2692bc028fed91f1': `Caps Lock`,
's27056379e0acfdb0': `Verlicht`,
's27076e66c5d483ba': `Verticaal uitlijnen`,
's2712dc5641a33226': `Pakketregisteraccounts zijn bedoeld voor ontwikkelaars en stellen je in staat om een
          of meer registers te configureren`,
's27cc88818cc46ff6': `Stabiel`,
's281d957112b10f12': `De HTML van het document direct bewerken`,
's28b6246ce616a548': `Een tabel kolomgroep invoegen`,
's29a1c26521879b9f': `Afschalen`,
's29acfd2778e8c377': `Geavanceerde tekstopmaak verbergen`,
's29b24c06315e9343': `Een invoer invoegen`,
's29eb103449472e3b': `Een koptekst invoegen (niveau 3)`,
's29ee7434494a0dfe': `Een koptekst invoegen (niveau 2)`,
's29f21c34494d614d': `Een koptekst invoegen (niveau 1)`,
's29fbfc3449557f72': `Een koptekst invoegen (niveau 6)`,
's29ff743449588131': `Een koptekst invoegen (niveau 5)`,
's2a031834495bcdb4': `Een koptekst invoegen (niveau 4)`,
's2a75c946ef4dcab7': `Diverse`,
's2b2ae20d26f78ac2': `Blok`,
's2b8f50c64be440f7': str`Selecteer 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Bestel`,
's2bad2d24def4aa0b': `Regeleinde (CJK taal)`,
's2ceb11be2290bb1b': `Annuleren`,
's2ced8e8fafb499f6': `Element verwijderen`,
's2d986d31f8d67357': `Een veldset invoegen`,
's2d995a37cf5e4995': `Een NoScript invoegen`,
's2de969afacdaa7a6': `Vorm`,
's2df075aface0dab8': `Deel`,
's2e192b19ed15fcf6': `Pagina`,
's2e39b99cf23606fa': `De opmaak van de geselecteerde elementen instellen`,
's2e4818861000b13f': `Lay-out`,
's2e66bf8b833858f3': `Oeigoer`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Overloop (y)`,
's2edd6688a65e21f0': `Overloop (x)`,
's2f0bcdffc92a786b': `Rechts zweven`,
's2f2044f2431a32d5': `Rubriek`,
's2f4d4bfbc466d91f': `Albanees`,
's2f8da2cb5f236588': `De naam van je pakket. Moet scoped zijn, bijvoorbeeld \`@org/pkg\`. `,
's30cce87854901922': `Kleuterschool`,
's3124653c272f054c': `Kolom regel kleur`,
's314a4f7685c8e824': `Altijd`,
's31c06e226322f065': `Wezen vermijden`,
's323dcde72b850272': `Publieke toegang`,
's32911e52ee8ac745': `Plaats een sleuf`,
's337a1e9022a8d19f': `Tabel`,
's33c1450d2822bb0f': `Een figuurbijschrift invoegen`,
's33c18d5a4cbffa2a': `Iers`,
's33f85f24c0f5f008': `Sla`,
's342b0cabfa672822': `Help de gebruiker je widget te vinden`,
's3437e0d9899e7ae1': `Telemetriegegevens verzenden over uw gebruik van WebWriter.`,
's344ea8f4939cdc98': `Kleur`,
's34dcda3b0f9d5a98': `Schakel url`,
's34f724979a124c50': `Stelt de achtergrondkleur van de geselecteerde tekst in`,
's355b21b89ce5d9c5': `Details`,
's35ae5f4e0fa2777b': `Aangepast uitlijnen`,
's35aeaff1425bca9e': `WebWriter ondersteunt geen media van het type `,
's35c3125c7750681e': `Blokcitaat`,
's3643189d1abbb7f4': `Code`,
's3649bacefe731bf6': `Schakelen Toolbox`,
's365280e16a8ea32d': `De selectie kopiëren`,
's366991b9c9287765': `Rechts`,
's36a194e38d653a26': `Annotatie van gegevens`,
's36b3cefdcb897f15': `Perspectief`,
's372fae706048ce41': `Even-oud`,
's377e24af9628c37e': `Geordende lijst`,
's37a8c35f6581da5f': `Geen anker`,
's37fa3b9cd51c2dfd': `Stelt de lettergrootte van de selectie in`,
's380d17664bb69531': `Kolom invoegen vóór`,
's3815184eb09f0dcf': `Cursor`,
's382a2aa3984474dd': `Maak`,
's38980f98cb07ceb8': `Het actieve document opslaan als kopie`,
's3914cb410fca44d4': `Importeren`,
's3a179f6db2972384': `Positie van Ruby`,
's3a5ca02f282d247e': `Deel...`,
's3ae67088bbefba98': `Pakketten`,
's3b0ab4b52326316f': `Licht`,
's3b3ea038c5d3bb06': `Divisie`,
's3bdad99768e11911': `Verkenbaar`,
's3cb47df8290fa94c': `Een optie invoegen`,
's3cf89cb47fdde7e9': `Link`,
's3d09398e555ee5f9': `Geavanceerde opties`,
's3d249bb480032121': `Lijst`,
's3d3efd1e19bdcfb4': `Annotatie datum/tijd`,
's3d6a732c792ccb9e': `Ruby Annotatie`,
's3d93f9ea0c5a13fa': `Afbeelding`,
's3d9548e211b958ce': `Overlappingen overslaan`,
's3e092e9d1ee2c5bb': `Clip`,
's3e78ddc9a48a608d': `Mooie`,
's3eb6d1e6e79ed7c4': `Geen documenten gevonden`,
's3eca5a034978754b': `De selectie verwijderen`,
's3f06e9abb6ebcb79': `Personages`,
's3f1e7a3f2b283d3b': `Marge`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Een artikel invoegen`,
's3fd83566dd643d10': `Een legende invoegen`,
's3fe72792941c18f9': `Tekst onder`,
's3ffcdc5db5e7d0c5': `Omgekeerd`,
's40e3826b7f74a3b5': `Pan (rechts)`,
's40f07d7859284a44': `Dominante basislijn`,
's4101ada154a1b958': `Midden`,
's410c465a5993f82d': `Mogelijkheid tot lijnbreuk`,
's41322d19c928c603': `ICT`,
's417b90913e05bc17': `Voorbeeld`,
's418f2020fe996832': `Wijzigingen bevestigen`,
's41c724f0698148e9': `Markeer de selectie als een sneltoets`,
's41f65a763f8e44ab': `Tabel kopgroep`,
's42721130228841b0': `Slag doos`,
's429bd646f1cf8bc6': `Met Grammar LLM-accounts kunt u de Grammar LLM API gebruiken om grammatica in tekst te corrigeren.`,
's429dd933ba95549b': `Een adres invoegen`,
's42e470ef1d707a28': `Automatisch spelen`,
's42ffdab1291fb3de': `Rij invoegen na`,
's430831017f3f0499': `Schuinte (y)`,
's430bd5017f42511c': `Schuinte (x)`,
's433ba70286202ceb': `Breek alle`,
's441b20a8a50e36b4': `Macedonisch`,
's445b8acb9206db6e': `Weggooien en annuleren`,
's446a924922651ea0': `Tekst benadrukken`,
's44cdba92713de38e': `Rastergebied`,
's45518abd911471d0': `Kroatisch`,
's456a8d744313852a': `Ruimte rondom`,
's4634541f5056a546': `Abchazisch`,
's46d4abe6255cb9e1': `Snelkoppeling opnieuw toewijzen`,
's4730c232e7209c40': `Trim beide`,
's474f0eec369d02a4': `Voorbeeld output`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Markeer de selectie als een datum/tijd annotatie`,
's47ebf3a8fb3b10c1': `Oriëntatie`,
's4802bb8eb52fbdeb': `Portaal`,
's4802e47fe2e95134': `Optie`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Tekst schaduw`,
's4993444bfd3f3e5e': `Instorten`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Masker`,
's49dd67aed00029ef': `Wiskunde`,
's49e763aed00877a8': `Hoofd`,
's4a894f57eba1cf1e': `Toetsenbord snelkoppeling`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Hard licht`,
's4b2c143acf931122': `Lijnhoogte`,
's4b58c01e2578f5e4': `Legenda`,
's4bbff4e008690da1': `Pagina vermijden`,
's4c1535f316305a2a': `Inspecteer de selectie`,
's4c402ff5355fd310': `Bidirectioneel overschrijven`,
's4caed5b7a7e5d89b': `Engels`,
's4cb38675a21b2c98': `Niet-ondersteund type eigenschap '\${desc.type}' (verwerkt als JSON)`,
's4cc8391f172c0cdf': `Rondleiding beëindigen`,
's4d528b416ac8dee2': `Een kopgroep invoegen`,
's4d546f6c87128d5b': `Ruimte eerst`,
's4dcb9315f6527f9c': `Uitvoeren bij herladen`,
's4e191bdb4700a6e9': `Overscrollen (x)`,
's4e1c7fdb470386ac': `Overscrollen (y)`,
's4e2562fe3990e621': `Fout bij het aansluiten`,
's4e361bf8eef3759a': `Woordbreuk`,
's4ea0f21fc2a338a1': `Omhoog`,
's4eace13b3ed74187': `Kanttekening`,
's4efee5b48a4593cb': `Lus`,
's4f26e7cb7c0a8318': `Vectortekening`,
's4fd2e638aabb0bb3': `WebWriter ondersteunt het insluiten van veel verschillende bronnen. Plak gewoon een
          link naar inhoud van:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Thai`,
's5015a8fb33b98872': `Dun`,
's50489ffb1bde152e': `Invoeging`,
's5068560b8d39663d': `Klikbare kaart`,
's517acbf1f96324f9': `Gewicht`,
's523eb9043213ff0d': `Cursief`,
's52777d434baeed9b': `Een voortgangsindicator invoegen`,
's52af5d7ac34c2163': `Tabel Rij`,
's52e0bdc3ee304436': `Plaats een meter`,
's531056f039febd39': `Een selectie invoegen`,
's536695196d0b6dc3': `Faeröer`,
's542fcefa0bbaed86': `De gereedschapskist openen of sluiten (alleen op smalle schermen, anders is de gereedschapskist altijd zichtbaar aan de zijkant).`,
's5432ad3c84273229': `Afbeelding`,
's543906d1db8b2283': `Bewerk `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Cambodja`,
's54897f2764b0e4d0': `Installeer dit widgetpakket`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Markeer de selectie als zeer belangrijk`,
's55905c735052d295': `Thematische onderbreking`,
's5590dbf7e425789d': `Label`,
's5623aa2f83b05c76': `Tibetaans`,
's564d1648b1ceee9f': `Actueel`,
's565cd5ffb0158c46': `Regio vermijden`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Ga terug`,
's5787c6d5b3b5541a': `Clip pad`,
's579c69f419b6caef': `Glad`,
's587ac858dd80f6fa': `Subscript`,
's58bec0ecd4f3ccd4': `Strikt`,
's59404f5593c32fdc': `Lettertype kerning`,
's5941292bb77281ab': `Noors Bokmål`,
's599dcd2472c75c19': `Paragraaf`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Markeer de selectie met een gegevensannotatie`,
's5a356677b61a6b7e': `Moldavisch`,
's5b474b5c0ac0c7c4': `Tabel kolomgroep`,
's5b517ac216f9ee62': `Zijwaarts`,
's5b8cc9bb61ddce15': `Een alinea invoegen`,
's5bba2ac2e53bd1fd': `Kirgiz`,
's5be80ad6b8301710': `Inline start`,
's5c1ecf88259b79f9': `Presentatie`,
's5c2a1a52c0389c30': `Engineering`,
's5c63af7695445fcf': `Tekststijl`,
's5d18ca4c3111be6f': `Een tabelkop invoegen`,
's5d87c1e588f48d90': `Praktijk`,
's5d929ff1619ac0c9': `Zoek op`,
's5da52af9b083c29a': `Model`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Aanmelden`,
's5e2cba97c0d971bd': `Pakketten herladen`,
's5e53415a6d5719ad': `Sociale wetenschappen`,
's5e6a7a0c30d2a270': `Overlappingen overslaan (automatisch)`,
's5e9e8e4d21bafedc': `Voedselproductie`,
's5ed03bb1f3a15949': `Afbeelding`,
's5f43af3669b1e098': `Bron`,
's5feaf7fd7ee567c8': `Woord breken`,
's600fd23c9ce971e8': `Het actieve document afdrukken`,
's602bbd28dae2c60f': `Zelf starten`,
's60ff598dfcf2c773': `Onder Rechts`,
's61053f0e3ebbd272': `normaal`,
's613c6ff83883c04f': `Tabel Kolom`,
's6196153c4b0c1ea0': `Installeer`,
's61c017f6d5c303af': `Fries`,
's61ded17ca3f48c82': `Offset onderstrepen`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Selectie kopiëren`,
's624e31cd4f1b89d4': `Vloeiend scrollen`,
's626daf42b1ab7df7': `Links uitlijnen`,
's6280bf993915c57a': `Scrollmarge`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Beschrijving`,
's63dfc5b1c1c27849': `Jiddisch`,
's63e03c70f67ebf9c': `Context`,
's63e71d20d1eaca93': `Duits`,
's640bc7710d0143ce': `De laatst ongedaan gemaakte wijziging in het actieve document opnieuw uitvoeren`,
's64dc1fc7e3db45c9': `Een nieuw document maken`,
's65ac276544ba33cd': `SVG-bestand`,
's66765c420ee578e4': `Gelijkmatige ruimte`,
's669b18c6d2d9c95b': `Geen`,
's6747dbf4ad6063ba': `Zelf beëindigen`,
's6787497df07fa97e': `Kan over stops scrollen`,
's67c2b60a506a09e4': `Secundair onderwijs.`,
's680bd4d926cd5a84': `Behoud 3D`,
's6827930ef1aeaf99': `Basis URL`,
's684a16f3c711394d': `Meer dan rechts`,
's687e27f036a71b32': `Isoleer`,
's68b87d7b61052dc3': `Tabel rij`,
's68e0e3a2bab7ce3e': `Vermijd`,
's690da6b432987c6f': `Maakt automatisch een back-up van wijzigingen in het huidige document. Wijzigingen worden hersteld wanneer WebWriter opnieuw wordt geladen.`,
's69311c4e25074fb3': `Middelbare school`,
's697400b541fbc3cd': `Onder`,
's6988ab5d47593a26': `Je hebt de nieuwste versie van WebWriter.`,
's69a49786a8009f43': `Zoek pakketten...`,
's69b12144dbb6544d': `Laotiaans`,
's69d88ef4b2618980': `Omslag`,
's69fbbdb8ad2a084a': `Verduisteren`,
's6a31eff1ec4f71ad': `Achtergezicht verbergen (3D)`,
's6ac62e1c8c66f3bb': `Compacte superscr.`,
's6b585ba37cdb8260': `Erven`,
's6b61f8abf89586be': `Hebreeuws`,
's6bd7a02fdf93e653': `Inhoud uitlijnen`,
's6cfc66b824ea05ba': `Scherpe randen`,
's6d02dc19e21eb49c': `Top`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamees`,
's6d8b3b8047ed378d': `Meng mengmodus`,
's6d8c02aee480af7a': `Menu`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Een stijl invoegen`,
's6e288a119281f4c2': `Tekstweergave`,
's6e4c20c6debcd5ca': `Aangepast rechtvaardigen`,
's6f84199e62584905': `Voorgeformatteerde tekst`,
's6fb3053e7244d326': `Andere velden`,
's70178e04a3b691b6': `Instellingen openen`,
's7031ca562378bde6': `Geometrische precisie`,
's7060970b5ed20a58': `Interactiviteit`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Toon onstabiele pakketten`,
's71dec51005acc1e4': `Rij dicht`,
's72f2a02e2a5a4ee3': `Media`,
's730182ad28374cda': `Object`,
's731678e227a20559': `Dit apparaat`,
's736904f276fbd441': `Natuurwetenschappen`,
's739544d0c858c633': str`Of laat 
          ${0} hier 
        `,
's73cb20c838e761e1': `Snijselectie`,
's7417792bbe720149': `Opnieuw doen`,
's741fae02b3dd24f3': `Pixelated`,
's743f778233e42a3f': `Een terzijde invoegen`,
's744d993d03f29851': `Scherm`,
's748c0074eff45884': `Manipulatie`,
's74aa0039a87141e2': `Ellipsis`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Vulvak`,
's75109f5307578a61': `Welkom bij WebWriter`,
's75a27f43413e02c5': `Frans`,
's75d83fc3f0cfab40': `Kop`,
's762e5704cc84089d': `Andere stijlopties van geselecteerde elementen instellen`,
's77318393dfdb0775': `Rij verwijderen`,
's77e594ddcc10c774': `Commercieel gebruik toestaan?`,
's782eac2b3e80323d': `Markeer de selectie als benadrukt`,
's782f286a79cca35d': `Relatief`,
's78673a3539cb1915': `Linksboven`,
's78789724e789221c': `Maat`,
's789ff24c8f03f1a4': `Letterafstand`,
's7995733bf97c01cc': `Servo-Kroatisch`,
's7a99528e7b64635a': `Occitaans`,
's7aaf0c06e69600f1': `Fout met `,
's7ae49e142487766c': `Toegang Gemeenschap`,
's7af555180b30a947': `Open de ontwikkelaarstools`,
's7b4ba250601b8667': `Een sjabloon invoegen`,
's7b560d8693ed8f42': `Rechtop`,
's7b9994904c4f5b54': `Tadzjiekse`,
's7bdf0fd5b014d36c': `Sterk belang`,
's7beb1e77e82363eb': `De laatste wijziging in het actieve document ongedaan maken`,
's7c61118554a0ec36': `Maximaal (x)`,
's7c95876637f6a9d7': `Filter`,
's7cb4e55c59663b1c': `Bedrijf`,
's7cfe12cd14df9950': `Afmelden`,
's7d27db3c9639c6dd': `Alternatief`,
's7d8103f6f06f83d6': `Opvulling`,
's7d864465dddbb50d': `Formaat wijzigen toestaan`,
's7de0e28d6c309a4e': `Aanraakacties toestaan`,
's7dea785045c3cc74': `Druk op nieuwe toetsencombinatie...`,
's7e0b179d4d1414eb': `Link invoeren`,
's7e6570f2f1ae320f': `Lettertypen samenstellen`,
's7ecb1f29332293e5': `Basislijn uitlijning`,
's7ed13ccddb1bf3c3': `Overlay`,
's7edbe0b213199995': `Bachelor`,
's7ede1c55e35ce9d6': `Simulatie`,
's7f09197a4814079b': `Interactiviteitsopties instellen voor geselecteerde elementen`,
's7f326a142e856656': `Stijl`,
's7fcb35d23be1e643': `Veld Set`,
's80570196a9ce6d11': `Telemetrie inschakelen`,
's806f84eb0ace116e': `Zie wat je hebt geselecteerd en wijzig het. Kopiëren, knippen, plakken, vastpinnen of lay-out wijzigen. Biedt verschillende opties afhankelijk van je selectie, bijvoorbeeld opmaak voor tekst.`,
's80a42b81c52d4d8f': `Caret kleur`,
's80b71fc6f43c5ce1': `Los`,
's812cbda653daaeba': `Deze functie is nog niet geïmplementeerd`,
's814d528c8af55807': `Definitie lijstitem`,
's81c3d8809658b951': `Kasjmiri`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Ga verder`,
's8247d32213e35f24': `Een hoofd`,
's82665b2ffabc9c0a': `Website`,
's828b1ecea8715884': `Pan (links)`,
's833bd0422a7ef95d': `Tabbladgrootte`,
's83420ad7b6a14db5': `Schakelen tussen hulpmiddelen`,
's83c15613b6f6f3c8': `Alleen online`,
's83cd32b685ccc9b7': `Besturingselementen`,
's83f26d02dd7aa681': `Zichtbaar`,
's840fa49e8989c028': `Positie/Vorm`,
's844a76d1843ceb3c': `Terugzetten naar standaard`,
's84e4e8ae645b82ac': `Rechtsboven (y)`,
's84e9c7f8785ca60b': `Een formulier invoegen`,
's8517ae4da104b004': `Tabel Kolom Groep`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Licentie als Creative Commons OER?`,
's85f9aa6d3ea0e421': `Tabel voettekst groep`,
's864b0e6270e97246': `Markeer de selectie als nevencommentaar`,
's8670e5ad3bf0dcf8': `Opslaan als`,
's8688d74dd3716d6e': `Sneltoetsen voor opdrachten`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Vorm marge`,
's87cefc710b3567fb': `Bevat`,
's88676f992b2965db': `Celinhoud uitrekken`,
's886897f2fd4edb99': `Verborgen`,
's886c5db2a5579873': `Concept`,
's888c71e8fcb916d3': `Autosave`,
's88a62d29529948fb': `Een tabel invoegen`,
's89950d86c8004d4b': `Geen overlappingen overslaan`,
's89bca7498f20e041': `Achtergrond Clip`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Pauze voor`,
's8a4ff2bd9c13498c': `Opnemen`,
's8a6585c48ea104e9': `Lege cellen verbergen`,
's8a9eb438abac7c6a': `Etiketten`,
's8b0432eecbd8b034': `Update`,
's8b7580c35e2aef87': `Linksboven (y)`,
's8bc4affa761aa8a2': `Een afbeelding invoegen`,
's8c7f51cb067644c7': `Gegevenslijst`,
's8d342ecaa9e75b9b': `Relatie`,
's8d797888455f4147': `Pauze ruimtes`,
's8d83386457e91813': `Je wijzigingen ongedaan maken/gedaan maken of een voorbeeld bekijken vanuit het perspectief van de leerling.`,
's8d8643013a7754d1': `Tekst uitlijnen`,
's8df30fe2a50d3479': `Voeg een regeleinde toe`,
's8e715248c3a78446': `De selectie knippen`,
's8f29e48d6b9a1aa8': `Een rij met tabelkop invoegen`,
's8f4be9f086eb530f': `Ongedaan maken`,
's8f533296a536965e': `Opslaan als...`,
's8fad58c831ecf017': `Ruby tekstcontainer`,
's8ffe7abcbed8eb43': `Verticaal, van links naar rechts`,
's90105521fcc40453': `Met WebWriter Cloud-accounts kunt u documenten online opslaan en delen met uw
          leerlingen. Voeg hier een account toe en het zal beschikbaar zijn als locatie voor het
          opslaan, laden, delen en openen van documenten.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Lettertype palet`,
's90f7c1cf501ea0a7': `Kleurontwijking`,
's91093e0b087911ba': `Nadruk op positie`,
's919e1724f589c9b1': `Sleuf`,
's91c5ed7769d00b65': `Insluiten`,
's9219acd5bef6269e': `Onder links`,
's92548405912d46bf': `Scroll snap uitlijnen (y)`,
's9258280591309342': `Scroll snap uitlijnen (x)`,
's927d796559f49439': `Achtergrond Oorsprong`,
's92b177e579ef7b97': `Nadruk`,
's92f846b9be2e8e8d': `Markeer de selectie als cursief`,
's93566b84230af4f5': `Een afbeelding invoegen`,
's936aa0b239679585': `Een thematische onderbreking invoegen (meestal weergegeven als een horizontale lijn)`,
's9370dc6afa716b57': `Grens`,
's93f083e654a45715': `Bretons`,
's94653c76b2d86a04': `Gedefinieerde termijn`,
's9485af2e7cd9418f': `Basisschool`,
's94d2eee44b292567': `Geavanceerde opties schakelen`,
's94d61907ee22a8c1': `Koreaans`,
's94eb1effbbb6498b': `Overloop`,
's951aa3a6439f1271': `Lijst marker`,
's9565553d163fc92a': `Script`,
's957787fc6b7ea5c0': `Pan (omhoog)`,
's95c161f68e5180a5': `Selectie inspecteren`,
's95d56e58f816d211': `Nederlands`,
's95d8e41a64635c7c': `Witte ruimte`,
's95de7e1eff6c053e': `Horizontaal, van boven naar beneden`,
's960d3a90ac199368': `Reto-Romaans`,
's96532132a29dd542': `Audio invoegen`,
's96a045dcade75ad0': `Kolom dicht`,
's9781a5bb3fcb26a3': `Selecteer eerst een bedrijf`,
's978522fbc9577a7e': `Somalische`,
's97881699a2b21d5b': `Rij afstand`,
's97aa76056a81bd36': `Metriek`,
's986facb3ecc9602c': `Zijwaarts, van rechts naar links`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Extern bestand`,
's98977a87d1b93941': `Informatie, stijlen en scripts opnieuw instellen`,
's990d0e0fa2ab00b5': `Galicische`,
's99229574e5692f19': `Groenlands`,
's99a990f3841ad283': `Bestanden van `,
's99b38e000175cc84': `Doorhalen`,
's99f110d27e30b289': `Titel`,
's9ab10fbf4c7a7322': `Positie onderstrepen`,
's9abadcc828884d7b': `Tekstveld`,
's9b7cd8860c8fc922': str`
          ${0}
          wordt overschreven. Weet u het zeker? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Achtergrondkleur`,
's9c8df9626d152d5a': `Definitie lijst term`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Tabel kolom`,
's9cf68f87b8e6122f': `Azerbeidzjaans`,
's9d167ef77aed79b6': `Laag`,
's9d2d00982edafabb': `Turks`,
's9d430adc5be110e9': `Rij Achteruit`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Verwijdering`,
's9df571714a1efb44': `Er is een automatisch opgeslagen versie van deze explorable beschikbaar. Laden?`,
's9e28faa598332e2b': `Video invoegen`,
's9e3dbb678150edd4': `Lettertypefamilie instellen`,
's9e40e59654c8ad67': `Kolom`,
's9e85800d3700e31c': `Track`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Variant lettertype`,
's9f1ecdb3061d9cbc': `Ruimtes behouden`,
's9faf26107ed49fb9': `Een tabelcel invoegen`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Overgang`,
's9ff3121d30f88d52': `Normaal`,
's9ffe1bbe64712bf1': `Canvas`,
'sa00df4e39c72d3b4': str`
          ${0} wordt niet ondersteund 
        `,
'sa013e119fec906fb': `Rij`,
'sa01e7bf33563ef72': `Achtergrond Bijlage`,
'sa126cf8c627cec1e': `Afbeelding renderen`,
'sa13f72278add7513': `Onder recht`,
'sa1647e3b36ec08d7': `Combineer rechtop`,
'sa172190ea21f9b1c': `Ga naar de instellingen, open een explorable of maak een nieuwe.`,
'sa1c6c459b9b5115c': `Absoluut`,
'sa2cba871f6cdd99f': `Assamees`,
'sa2eff4dad1c119f1': `Rastersjabloon`,
'sa30c12014e955946': `Russisch`,
'sa30f1981fd1cd441': `Lettergrootte`,
'sa311a24c1471a974': `Document`,
'sa352d168b262aa06': `Een voettekst invoegen`,
'sa37fee6a52d18063': `Document verwijderen`,
'sa39c7ac1d37f3bce': `Markeer de selectie als een 'bidirectionele isolatie'.`,
'sa3b4c01623211544': `Kracht`,
'sa40fd43756fa8913': `Perzisch`,
'sa417644bef21a9aa': `Naamloos thema`,
'sa43800e28be1bdbc': `Decoratie kleur`,
'sa477cb1825dceb3b': `Soedanees`,
'sa492a51a707930fa': `Een blokcitaat invoegen`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Onderschrift onderaan`,
'sa50d3c35533f1d99': `Alle velden`,
'sa53c5cb03a8fda50': `Zet de selectie vast als knipsel in het palet`,
'sa557ae6bee9148a6': `Vooruitgang`,
'sa589e1df65dde0ec': `De grootte, opvulling en marges van de geselecteerde elementen instellen`,
'sa5c371b4bb75e590': `Links`,
'sa5c80e623459ffe4': `Een koptekst invoegen`,
'sa5df1bcdba46c3fb': `Figuur Onderschrift`,
'sa602e3fd3f2d98fd': `Animatie`,
'sa644d580d8a11e60': `Robijn uitlijning`,
'sa645d315510dc09e': `Pad van schijf kiezen`,
'sa65d4ad99f1d8c06': `Tekstachtergrond instellen`,
'sa6607436f60ccc1a': `Ests`,
'sa6f8d27bca557059': `Verplaats meta/link/stijlelementen omhoog/omlaag in dit element`,
'sa757645ad842da97': `Pauzes behouden`,
'sa75b95980cd80e78': `Redacteur`,
'sa7698b3d20a6d1ec': `Scroll`,
'sa778acc33947c7b8': `Rondleiding beëindigen`,
'sa78a67272a4a6f95': `Wiskundige formule`,
'sa79167651dce1e80': `Alternatieve tekst`,
'sa7af797a46c7d09a': `Tabel Voettekst`,
'sa7dbe35b758c138d': `Een canvas invoegen`,
'sa7dc6b8ef3f595dc': `Een bron invoegen`,
'sa8279f8211b3950d': `Pauzes en ruimtes behouden`,
'sa8b55cab62e439b5': `Kolom verwijderen`,
'sa8bbe0197d31b423': `Korte beschrijving`,
'sa9ff3b762365abe6': `Transformeer oorsprong (z)`,
'saa02e3762368ff35': `Transformeer oorsprong (y)`,
'saa065776236bfa28': `Transformeer oorsprong (x)`,
'saa33768e03c45fc8': `Bestandsgrootte`,
'saaad98061a20ac39': `Een wiskundige formule invoegen`,
'saab875d8cfcfe712': `Thema`,
'saad4380b9cc6cefd': `Wissel af over`,
'saaec15c97a9e4245': `Kolom Achteruit`,
'sab0c57df694a0a09': `Trim start`,
'sab4d9283896d9422': `Snap resolutie pixels`,
'sab55faae8e165407': `Vulling&lt;br&gt; zoals spleet`,
'sab5e7d2a069a2951': `Beroepscertificaat.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Rechts uitlijnen`,
'sac895c732f350ac5': `Donker`,
'saced41ddda8b2354': `Flexibele basis`,
'sad190f86451081c0': `Nepalees`,
'sad6be321164d08c8': `Compacte wiskunde`,
'sadd352cc7f6f2307': `Opzij`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Zweeds`,
'sae1c7f13b7c0c47f': `Start`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tataars`,
'saf312eaeec77a802': `Een beschrijvingslijst invoegen (woordenlijst, begrippenlijst)`,
'saf3da7c95cb17260': `Markeer de selectie als superscript`,
'saf440a0a592f2835': `Bijwerken naar`,
'saf9e5134ba1a7d30': `Scroll snap`,
'safc6f203342d09e2': `Schakelt de voorbeeldweergave voor het actieve document in`,
'sb0a7e3adf4a125ee': `Rechtsboven`,
'sb0a974028c99ca6d': `Aanpassingen toestaan?`,
'sb0d4f0f7993cf085': `Lettergrootte instellen`,
'sb0f3327210fe18fc': `Kolommen`,
'sb0f93c1c60c0249a': `Basis Robijn`,
'sb1494c08c8c720d1': `Tekstkleur instellen`,
'sb19611adbc88f711': `Geavanceerd: Toon bronbewerkingsopdrachten, bijvoorbeeld om de HTML van het document te tonen of om aangepaste stijlen en scripts toe te voegen.`,
'sb206d700d26b14ff': `Onderstrepen`,
'sb233557012dcb328': `Naar beneden`,
'sb26035b596566abf': `Naamloos`,
'sb2cda80610c8d6ea': `Alle ruimte`,
'sb2dc787b0983ebc6': `Litouws`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Midden`,
'sb3ba3276ae93627c': `Een voorgeformatteerd tekstblok invoegen`,
'sb430f5b4824de0d3': `Kies een lay-out`,
'sb43db07b24da018a': `Amhaars`,
'sb45f9fb4dba6e71a': `Niet-ingestelde`,
'sb4e003a459464d85': `Koerdisch`,
'sb4f0310e6787d098': `Oezbeeks`,
'sb4f1dffbb6be6302': `Duidelijk`,
'sb51270e19988f9bd': `Regio`,
'sb59d621e3c93cc27': `Gedeelde celgrenzen`,
'sb5e9e1776242b028': `Interacties`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `Doctoraat`,
'sb6103872073d369e': `Details invoegen`,
'sb616811735bfbafd': `Tabel cel`,
'sb628960829e223bb': `Alle overlappingen overslaan`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Toepassen en importeren`,
'sb66e2181a7b5738a': `Door telemetrie in te schakelen, geeft u toestemming voor het verzamelen en bewaren van gegevens in overeenstemming met onze`,
'sb67e0e7c0869f982': `Verschil`,
'sb68e83cda6c85af8': `Tabel koptekst`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Dikte decoratie`,
'sb70c17f7899f9b01': `Latijn`,
'sb71941f552f3504d': `Speciale waarde instellen`,
'sb740eab4afd5a710': `Raster autostroom`,
'sb741b6e0ca589122': `Terugkeerlaag`,
'sb7c77d0415de05cf': `Tests uitvoeren`,
'sb7fb7568f6883ab8': `Het actieve document delen`,
'sb85774dc5d18ff0f': `Bevestig`,
'sb85b1e36579852a6': `Ongeldig e-mailadres of wachtwoord`,
'sb884fa76bfc55429': `Arabisch`,
'sb8a3d4df7d1c5e6b': `Saldo`,
'sb8f610a0e8df91fc': `Helderheid`,
'sb8f855b49234b81b': `Toepassen`,
'sb905da066c10182c': `Plus donkerder`,
'sb940ade1bd81be7e': `Onder Links`,
'sb9e9a7dd45966756': `Markeer de selectie als vet`,
'sba509fd8ed61d1d5': `Niet-opgeslagen bestand`,
'sba64d8954d027206': `Opaciteit`,
'sba88d90cd6c751b3': `Kolomregel`,
'sbaf0a7c417e388af': `Gezondheid`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Achtergrondfilter`,
'sbb85a407d730e13d': `Een zoekopdracht invoegen`,
'sbb86c6c96f598bb8': `Gemengd`,
'sbba0156f795d8c07': `Selectie bewerken`,
'sbba865d4b437944f': `Attribuut`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `verwijderen`,
'sbc5f2a81604baf9b': `Rubriek 6`,
'sbc5f2b81604bb14e': `Rubriek 5`,
'sbc5f2c81604bb301': `Rubriek 4`,
'sbc5f2d81604bb4b4': `Rubriek 3`,
'sbc5f2e81604bb667': `Rubriek 2`,
'sbc6953a36ced943f': `privacybeleid`,
'sbd181cd54b8402a4': `De selectie bewerken`,
'sbd35ee879d9cf770': `Robijn tekst`,
'sbd40f40cbadd38d5': `Dit widgetpakket verwijderen`,
'sbd72dc858de95ce8': `Birmaans`,
'sbe3c60c65f129daa': `Geesteswetenschappen`,
'sbe4a7c8f231739b3': `of bestand plakken/loslaten/kiezen`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Een regeleinde invoegen`,
'sbf00e1ee999ea94e': `Een script invoegen`,
'sbf519920c2017d67': `Opknoping`,
'sbfa01f189a68d3e9': `Flex groeien`,
'sbff54e740c4086eb': `Onbekende pakketten tonen`,
'sbfff51feacf30196': `Sanskriet`,
'sc0ceaa9843510f67': `Turkmenen`,
'sc1611c0558728a2a': `Positie`,
'sc1a155cc25899250': `Tabel rij groep`,
'sc1aa1f6051b7102a': `Roemeens`,
'sc1edebeaef92b7bd': `Vaste tabelindeling`,
'sc1fff4f356dfb2fb': `Transformeer`,
'sc24bda3c061fddf8': `Klikbaar gebied`,
'sc252a4e091763606': `Een voettekst voor een tabel invoegen`,
'sc2536e077514accc': `Scrollen`,
'sc275dd00036d16cb': `Citaten karakter`,
'sc28864200d2a3799': `Kopieer QR Code als afbeelding`,
'sc2a24a9dd41a9503': `Decoratielijn`,
'sc2b734cca2fa643b': `Pan (omlaag)`,
'sc2e2a0dbf03723b7': `Geavanceerd: Toon pakketten van onbekende bronnen in de pakketbeheerder (Waarschuwing: Kan onveilig zijn)`,
'sc3998b77d72c2932': `Een website invoegen (als een inline frame)`,
'sc3ac225273c8316b': `Algemeen`,
'sc3cfee84dbbf36ae': `Lokaal bestand`,
'sc3f09a9b6fa4fbed': `Binnen`,
'sc43767deea72e9f3': `Beschrijving Lijst`,
'sc462bbdd36bcba6b': `Referentievak`,
'sc4ee3e4ee994dafd': `Oekraïens`,
'sc50d09edf9325339': `Dialoog`,
'sc52b67794c06a0d3': `Perspectief oorsprong (y)`,
'sc52e8b794c0913d6': `Perspectief oorsprong (x)`,
'sc53de149fcaad713': `Inter-karakter`,
'sc546f489f9c0cced': `Schakelt de testmodus voor het actieve document in`,
'sc5bcf50d1b578d9f': `Instellingen lettertype`,
'sc5cb39478b9b7625': `Markeer de selectie als een subscript`,
'sc6415b50ff928294': `Lijst item`,
'sc650ff15b20fe9d3': `Draaien (z)`,
'sc6578b15b2154365': `Draaien (x)`,
'sc65aff15b2183e58': `Draaien (y)`,
'sc6da0f4a7e4d710e': `Lettertype taal overschrijven`,
'sc74e3567875ce255': `Zowel de tag van je widget als de naam van je NPM-pakket`,
'sc7eb080b96e244df': `Maleis`,
'sc8ac7ef92b95df3f': `Verplaatsen (x)`,
'sc8af536e2084ade0': `Palet`,
'sc8b022f92b992bc2': `Verplaatsen (y)`,
'sc8b39af92b9c2d81': `Verplaatsen (z)`,
'sc8d2c7f6c33a2b32': `Tekststijl (uitlijning, inspringen, spatiëring, enz.) van geselecteerde elementen
          instellen`,
'sc8fa0e3de389ef1c': `Lettergrootte aanpassen`,
'sc9474bf7a0668d73': `Samenvatting`,
'sc94e314312a8900c': `Tsjechisch`,
'sc980855a000b76ea': `Bodem`,
'sc98b103772de63f4': `Fins`,
'sca7cfe2bef51b2a5': `Wortel`,
'sca7fed2bef53cb99': `Rol`,
'scabe6ecee5e01fd2': `Maltezer`,
'scace301a88231cce': `Insluiten`,
'scbc55f622ec078c1': `Bekijk doos`,
'scbe537fc38ff4c13': `Raster autokolommen`,
'scc1db59d292cbc4c': `Sectie`,
'scc56b218a2689c42': `Armeens`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Opvulvak`,
'scd9cedeb5ece3adb': `Afbreken`,
'scdf536b65be39ec5': ` Maken/importeren`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideografisch`,
'sceecdd0bb404bc17': `Een optiegroep invoegen`,
'scf00d48fd5953a03': `Grieks`,
'scf932840a69dbb7c': `Portugees`,
'scf932a8577057752': `Voettekst`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Rechtsonder`,
'sd01178c54f648118': `Kolommen in balans`,
'sd03bff50f87f82d4': `Teken met koppelteken`,
'sd05a155fe09c2866': `Online bij gebruik van`,
'sd0864ea6cb6ef22e': `Gemeenschap`,
'sd10fdbe6caf9a998': `Regeleinde`,
'sd121d3b959b7888d': `Snelheid optimaliseren`,
'sd1a78e667a1a139f': `Markeer de selectie als een invoeging`,
'sd1cffad290ea5b3b': `Bewaar alle`,
'sd1f10284eeb17b25': `Fiji`,
'sd1f44f1a8bc20e67': `E-mail`,
'sd1f81984eeb7c0e8': `Vullen`,
'sd29dc07235eea0f5': `Offerte`,
'sd2addf69477cd4b4': `Pakket importeren`,
'sd2ed26defc646d47': `Achterdoek filter`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Vast`,
'sd3a288c1094b8a63': `Breedte kolomregel`,
'sd3c65ef5c380c046': `Inzet`,
'sd3dcb76f7b28adb8': `Lets`,
'sd3eca1e0f4209f6e': `Alles trimmen`,
'sd3f402df8619ddcd': `Deze informatie over jou wordt automatisch toegevoegd aan nieuwe documenten. Je kunt
          dit voor elk document wijzigen in de metadata-editor.`,
'sd4368b12645d3c0f': `Een portaal invoegen`,
'sd452cebf4a0313d1': `Commando's voor bronbewerking weergeven`,
'sd48cc52117f4d68b': `Italiaans`,
'sd52660ee947ca58b': `Een kolom in een tabel invoegen`,
'sd588d17a1b25c220': `Tekstoverloop`,
'sd5be6f6d85fc0c9b': `Zoeloe`,
'sd5bf67958b08b4cf': `Hoger onderwijs.`,
'sd5cf95145e4d89ca': `Dit fragment unpinnen`,
'sd5fd9d11a92f5b1d': `Linksonder (y)`,
'sd60c9bbc51375635': `Een knop invoegen`,
'sd66c4767fa3dde28': `Accentkleur`,
'sd679c8b1bf8cc8a5': `Kleine caps`,
'sd7086c4425c53c80': `Lettertype`,
'sd837f42ac7cbfb58': `Vorm (buitenkant)`,
'sd88076d2994ee0fb': `Uitsluiting`,
'sd89a2e529b31ef43': `Terugkeren`,
'sd8a345e95668b73b': `Verticaal, van rechts naar links`,
'sd8ce9e57270b030d': `Lettertype uitrekken`,
'sd8ecf227c7c49331': `Wiskundig`,
'sd8f923198e0c5c6a': `Einde`,
'sd9c21e5f60d6bdd8': `Deens`,
'sd9ff8e2612e63d50': `Grootte randvak`,
'sda2d76b976502a8d': `Open...`,
'sda344aacb837387e': `Positie in container`,
'sda5b6fa8b771f996': `Zweef links`,
'sda9254d1f1228e1a': `Hongaars`,
'sdb1595f5c742dfbb': `Invoer`,
'sdb711380a28fec75': `Een lijst invoegen (geordend)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Rechtsonder (y)`,
'sdc48456f9a27ae02': `Generator`,
'sdc70d81cf6c28533': `Georgisch`,
'sdd1ff479d04ac140': `Openbaar`,
'sdd2fc8919a9c3111': `Overvloeimodus achtergrond`,
'sdd35b688281b6dea': `Japans`,
'sddc49047f66a64ab': `Geen beschrijving gegeven`,
'sdef34fe08bb28b09': `Chinees (Vereenvoudigd)`,
'sdf62e305e1594805': `Markeer de selectie met een ruby annotatie`,
'sdf946172dfa0328f': `Superscript`,
'sdf9bc5d9b7f3e3de': `Uitlijning`,
'se036b53f145441cd': `Gemengde inhoud`,
'se06f459fccdc3ce9': `Laatste tekstregel uitlijnen`,
'se0a782a8be8e018b': `Noors`,
'se0cda6b80a1bb50f': `Slowaaks`,
'se0f67eae944f8f94': `Stomme`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Artikel`,
'se1f5bb0386c88f96': `Stelt de kleur van de geselecteerde tekst in`,
'se219da7b1e955c65': `Duidelijke opmaak`,
'se25e4f2cb77b8be8': `Taal voor de WebWriter-interface en nieuwe documenten`,
'se2796c5824ec8916': `Zichtbaarheid van inhoud`,
'se308836a594808b6': `Singalees`,
'se36c5b1baf5e0660': `Overal`,
'se39c065efa467782': `Baskisch`,
'se3b4c857f91f80d7': `Sneltoetsen`,
'se47baf2fd16b9d2b': `Sjabloon`,
'se48bd9e6c2a3109d': `Rekeningen`,
'se58467472725ad0c': `Beeldresolutie`,
'se58f06c2b0583ff7': `Coördinaten kiezen`,
'se5dc1e97fb743ade': `Afstand`,
'se619a501d1bfe6a5': `Wikkel`,
'se62385ac082368d2': `Markeer de selectie als een citatiebron`,
'se6297163cac9d276': `Bron bewerken`,
'se633223a0b88625e': `Plaatsing van cellen`,
'se638417c560cfe5c': `Breek binnen`,
'se64f418b4e733b6c': `Een uitvoer invoegen`,
'se6cdad455e2d8c02': `Een divisie invoegen`,
'se79c0a3ac70d8fb3': `Asp. verhouding (x)`,
'se79fae3ac710dc36': `Asp. ratio (y)`,
'se7fad370d8fb4cec': `Leesbaarheid optimaliseren`,
'se8a94b4effa2033e': `Alfabetisch`,
'se95d4e55ea186d9a': `Kleur schuifbalk`,
'se96d43a515b8451c': `Sloveens`,
'se96fd76ba1b2975a': `Centraal`,
'se9ac05f36b004eb0': `De inleidende tour verbergen. Uitschakelen zodat de rondleiding weer wordt weergegeven.`,
'se9b1fec72ffd8f48': `Lokaal`,
'sea24bdcaa2bd2dec': `Verplichte klik`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Schakelt de metagegevenseditor`,
'sea896ed51ad33287': `Geen specifieke stijlen beschikbaar`,
'seaaaeb09e3b4e78b': `Opdrachten bewerken`,
'seabae79729c4b2ad': `E-mail Toggle`,
'seaecc8267bad6234': `Middelbare school`,
'seaf97719986faf4f': `Gap`,
'seb19675a580f0628': `Kolom vermijden`,
'seb4e52ef5ec7a7dc': `Kleuren/Effecten`,
'seb8982ae8c3cdcc5': `Indonesisch`,
'sebbced89e0db2894': `Eerste basislijn`,
'sec02109a0dd2a6c8': `Benadruk kleur`,
'sec2557a35b702525': `Variabele`,
'sec2da4aa7a02b925': `IJslands`,
'sec30fbb20f102670': `Samenvatting invoegen`,
'sec8b0b6c729816b6': `Rubriek Groep`,
'seccd05955adb76bc': `Poster`,
'sed17285cd25d6389': `Directory waar package.json zich bevindt`,
'sed318ec045c5144f': `Meer dan`,
'sed713f1b916fb469': `Afstand tussen randen (x)`,
'sed74a31b9172942c': `Afstand tussen randen (y)`,
'sed86bd0deb2e5372': `Tekst transformeren`,
'see2fcaedf9743ec6': `Locatie`,
'seec6798afe90ffc8': `Afdrukken`,
'sef00c258bc1ecf1e': `Deze verkenner heeft niet-opgeslagen veranderingen.`,
'sef23dd271edd4a8b': `Linksonder`,
'sef24caccbd4645ef': `Flex krimp`,
'sef49aec68fd1dc66': `Naam`,
'sef73fe18e351eb35': `Trefwoorden`,
'sef75f458d77491af': `Optiegroep`,
'sefcf950b3cc4fc3b': `Taal`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Inhoud`,
'sf0cab2483f66aa2e': `Aangepast`,
'sf0e261e04eda82ff': `Uiterlijk`,
'sf1045382c1fd9a85': `Exacte afdrukkleuren`,
'sf14c35392ec7bf10': `Deze functie is niet beschikbaar in Firefox. Ze is beschikbaar in Chrome of Edge.`,
'sf14f9d5f9f6ca342': `Plus lichter`,
'sf1868dc19e3917bb': `Spaans`,
'sf190149f9d8bbb2a': `Schrijfmodus`,
'sf1e79171c4856543': `Weet u het zeker? Deze actie kan niet ongedaan worden gemaakt, al je instellingen
          worden verwijderd en opnieuw ingesteld.`,
'sf21c1f60c7515f44': `Markeer de selectie als voorbeelduitvoer`,
'sf21fb4f4b9e8911f': `Breedte`,
'sf22a3737146ec910': `WebWriter kan SVG direct in het document insluiten.`,
'sf2514d5dc78b1654': `Widget invoegen`,
'sf28903d4ca0ddcfc': `Deze account verwijderen`,
'sf2ab37af0abc55ef': `Verberg intro tour`,
'sf2bdb0b4d7b9c039': `Bengaals`,
'sf2cbb5e519264e67': `Formaat zowel horizontaal als verticaal wijzigen`,
'sf2d5cbc2fe0ad65a': `Kleverig`,
'sf2d96d0eb32cb81f': `Animatie samenstelling`,
'sf2de3dbe2108637a': `Vormweergave`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Een track invoegen`,
'sf3c4da68b08a2590': `Malagasy`,
'sf471ec2496f904cc': `Wijzigingen weggooien`,
'sf4849bc200e279ed': `Tabel onderschrift`,
'sf486ca1fdbe08645': `Een figuur invoegen`,
'sf4b537d4cbd8f5fd': `Tekst boven`,
'sf4e0e02a5277ef23': `Een tekstgebied invoegen`,
'sf4f067d41efd4b83': `Schaal (y)`,
'sf4f3cbd41f002b46': `Schaal (x)`,
'sf4fa67d41f05a008': `Schaal (z)`,
'sf5197db2d5f2926a': `Draaien`,
'sf52d840949a980d1': str`
          ${0}
          zal permanent worden verwijderd. Weet u het zeker? 
        `,
'sf55d634dcc743595': `Diensten`,
'sf59c9081d106dd9c': `Markeer de selectie als een variabele`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Een document verwijderen`,
'sf65df67a03bebe4b': `Vereist voor deze widget`,
'sf6673729c03ae999': `WebWriter resetten`,
'sf67571992e7dc88e': `Volledige termijn`,
'sf6b4934598f7ed10': `Selectie toestaan`,
'sf6e1665c7022a1f8': `Wachtwoord`,
'sf79e0d78b56444f1': `Inline einde`,
'sf7a5f7a7c80c3082': `Beide`,
'sf7c0eba7c822e3d6': `Vet`,
'sf86bd4d2982f3b74': `Markeer de selectie als code`,
'sf8e82313fa411494': `Markeer de selectie als een link`,
'sf955eff73fb6b573': `Servisch`,
'sf9929e2d356260c5': `Vermenigvuldig`,
'sf993bb199fefbe04': `Alle`,
'sf9ecf969dd4b8164': `Beide randen`,
'sf9f2c719a04066ec': `App`,
'sfa49a5bb1a5d353e': `Privétoegang`,
'sfa59c7777e2a0eeb': `Een gegevenslijst invoegen`,
'sfaa0a67db5c11f72': `Eerste tekstregel inspringen`,
'sfb231a52211b133f': `Geen tekstomloop`,
'sfb68cae41d749423': `Initieel`,
'sfb9b6edb0ed378c9': `Citatie Bron`,
'sfbbab09dbe553571': `Een vectortekening (SVG) invoegen`,
'sfc00292e778b67e2': `Meter`,
'sfc63e31ac7c956ed': `Selecteer`,
'sfc815c9078bba30a': `QR Code downloaden als afbeelding`,
'sfcdd8e672c75b713': `Adres`,
'sfcebd18506f1e535': `Stroom`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Uitgang`,
'sfdb1e4d90981a535': `Dit document delen`,
'sfdeef3dccf409f81': `Dit sleutelwoord is vereist voor widgets`,
'sfe6e758ad2603c1d': `Master`,
'sfee1c12daf838935': `Kleurverbranding`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Een dialoogvenster invoegen`,
'sffa395f64ec6ac36': `Bulgaars`,
'sffdadf0a576fd802': `Hoogte`,
'spaceKey': `Ruimte`,
'tabKey': `Tab`,
'upKey': `↑ Omhoog`,
's2739460e44320108': `Chinese (Traditional)`,
'scbf29ce484222325': ``,
    };
  